import { useServicesContext } from '../../contexts/ServicesContext';
import { useMutation } from '@tanstack/react-query';

export const useUploadBlob = () => {
  const { uploadBlob } = useServicesContext();

  return useMutation({
    mutationKey: ['uploadBlob'],
    mutationFn: (file: File) => uploadBlob({ file: file }),
  });
};
